export default class Trial {
    mount(element) {
        this.parentElement = element;
        this.fields = [
            "firstname",
            "lastname",
            "email",
            "tos",
            "newsletter",
        ];
        this.errorElem = element.querySelector('[data-role="error"]');
        this.messageElem = element.querySelector('[data-role="message"]');
        this.buttonElem = element.querySelector('[data-role="submit"]');

        if(this.buttonElem) {
            this.buttonElem.addEventListener('click', e => {
                e.preventDefault();
                this.submit();
            });
        }

        this.buttonElemSub = element.querySelector('[data-role="subscribe"]');
        if(this.buttonElemSub) {
            this.buttonElemSub.addEventListener('click', e => {
                e.preventDefault();
                this.subscribe();
            });
        }
    }

    async submit() {
        if (this.isSubmitting) {
            return;
        }

        this.isSubmitting = true
        this.buttonElem.classList.add('loading')

        this.errorElem.style.display = 'none';
        for (const field of this.fields) {
            document.querySelector(`[data-role="${field}"]`)?.classList.remove('has-errors');
        }

        const payload = {};
        for (const field of this.fields) {
            const elem = this.parentElement.querySelector(`[data-role="${field}"]`);
            if (elem?.type === 'checkbox') {
                payload[field] = elem?.checked ?? false;
                
            } else {
                payload[field] = elem?.value ?? false
            }
        }
        try {
            const response = await fetch('/app/trial', {
                method: 'POST',
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (data.success) {
                // console.log('success');
                this.messageElem.innerText = 'Thanks! The download will begin shortly.';
                this.messageElem.style.display = 'block';
                this.buttonElem.style.display = 'none';
                const url = data['download'];
                const link = document.createElement('a');
                link.setAttribute('data-no-swup', true);
                link.href = url;
                link.setAttribute('download', 'trial-fonts.zip');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // Integrate with Buttondown without affecting the trial functionality
                this.subscribeToButtondown(payload.email, {
                    firstname: payload.firstname,
                    lastname: payload.lastname,
                    tos: payload.tos,
                    newsletter: payload.newsletter
                });
                
            } else {
                // console.log('nope');
                for (const item of Object.keys(data.errors)) {
                    if (data['errors'][item] === false) {
                        if(this.parentElement.querySelector(`[data-role="${item}"]`)?.type === 'checkbox') {
                            console.log('yeps');
                            this.parentElement.querySelector(`[data-role="${item}"]`).parentElement.classList.add('has-errors')
                        } else {
                            console.log('nopes');
                            this.parentElement.querySelector(`[data-role="${item}"]`)?.classList.add('has-errors')
                        }
                    }
                }
                this.errorElem.innerText = '';
                this.errorElem.style.display = 'none';
            }
        } catch (e) {
            // console.log(e);
            this.errorElem.innerText = 'Something went wrong. Please try again later.';
            this.errorElem.style.display = 'block';
            // this.errorElem.style.display = 'block';
        }
        this.buttonElem.classList.remove('loading')
        this.isSubmitting = false
    }

    async subscribe() {
        if (this.isSubmitting) {
            return;
        }

        this.isSubmitting = true
        this.buttonElemSub.classList.add('loading')

        this.errorElem.style.display = 'none';
        for (const field of this.fields) {
            document.querySelector(`[data-role="${field}"]`)?.classList.remove('has-errors');
        }

        const payload = {};
        for (const field of this.fields) {
            const elem = this.parentElement.querySelector(`[data-role="${field}"]`);
            if (elem?.type === 'checkbox') {
                payload[field] = elem?.checked ?? false;
                
            } else {
                payload[field] = elem?.value ?? false
            }
        }
        try {
            const response = await fetch('/app/subscribe', {
                method: 'POST',
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (data.success) {
                // console.log('success');
                this.messageElem.innerText = 'Thanks for subscribing.';
                this.messageElem.style.display = 'block';
                this.buttonElemSub.style.display = 'none';
                const url = data['download'];
                const link = document.createElement('a');
                link.setAttribute('data-no-swup', true);
                // link.href = url;
                // link.setAttribute('download', 'trial-fonts.zip');
                // document.body.appendChild(link);
                // link.click();
                // document.body.removeChild(link);

                // Integrate with Buttondown without affecting the trial functionality
                this.subscribeToButtondown(payload.email, {
                    firstname: payload.firstname,
                    lastname: payload.lastname
                });
                
            } else {
                // console.log('nope');
                for (const item of Object.keys(data.errors)) {
                    if (data['errors'][item] === false) {
                        if(this.parentElement.querySelector(`[data-role="${item}"]`)?.type === 'checkbox') {
                            console.log('yeps');
                            this.parentElement.querySelector(`[data-role="${item}"]`).parentElement.classList.add('has-errors')
                        } else {
                            console.log('nopes');
                            this.parentElement.querySelector(`[data-role="${item}"]`)?.classList.add('has-errors')
                        }
                    }
                }
                this.errorElem.innerText = '';
                this.errorElem.style.display = 'none';
            }
        } catch (e) {
            // console.log(e);
            this.errorElem.innerText = 'Something went wrong. Please try again later.';
            this.errorElem.style.display = 'block';
            // this.errorElem.style.display = 'block';
        }
        this.buttonElemSub.classList.remove('loading')
        this.isSubmitting = false
    }
    
    // New method for subscribing to Buttondown
    async subscribeToButtondown(email, metadata) {
        try {
            const response = await fetch('https://api.buttondown.email/v1/subscribers', {
                method: 'POST',
                headers: {
                    accept: 'application/json',
                    authorization: 'Token 11caeb03-d3ad-4913-87ec-26b2698136a1',
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    email_address: email,
                    metadata: metadata,
                    type: 'regular'
                })
            });

            if (!response.ok) {
                console.error('Buttondown subscription failed:', await response.json());
            } else {
                console.log('Buttondown subscription successful');
            }
        } catch (error) {
            console.error('Error subscribing to Buttondown:', error);
        }
    }
}

// const options = {
//     method: 'POST',
//     headers: {
//       accept: 'application/json',
//       authorization: 'Token $BUTTONDOWN_API_KEY',
//       'content-type': 'application/json'
//     },
//     body: JSON.stringify({email_address: 'telemachus@buttondown.email', type: 'regular'})
//   };
  
//   fetch('https://api.buttondown.com/v1/subscribers', options)
//     .then(response => response.json())
//     .then(response => console.log(response))
//     .catch(err => console.error(err));